import PropTypes from 'prop-types';
import OutlinedPillButton from 'src/common/components/shared/button/OutlinedPillButton';
import Text from 'src/common/components/Text';
import { DONATE } from 'src/common/constants/localizations/profile';
import css from './donateButton.module.scss';

const DonateButton = ({ text, url }) => (
  <a className={css.link} target="_blank" href={url} rel="noopener" data-testid="profileDonate">
    <OutlinedPillButton
      id="donateButton"
      className={css.donateButton}
      label={text || <Text name={DONATE} />}
    />
  </a>
);

DonateButton.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
};

export default DonateButton;
